import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersSkillEvaluationTermMutateType } from "~/domains";

type RequestDataType = {
  body: {
    businessSectionIds: string[];
    title: string;
    fromDate: string;
    toDate: string;
    publicStatusId: number;
    skillEvaluationStandardSummaryCategoryId: string;
  };
};

const request = ({ body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiManagersSkillEvaluationTermMutateType>(
      "/api/managers/skill_evaluation_terms",
      {
        skillEvaluationTerm: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersSkillEvaluationTermsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersSkillEvaluationTermMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
